import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { ToastrService } from 'ngx-toastr';
import { CompaniesService } from 'src/app/component/companies/service/companies.service';

@Component({
  selector: 'app-add-company-account-modal',
  templateUrl: './add-company-account-modal.component.html',
  styleUrls: ['./add-company-account-modal.component.css'],
  animations: [
    trigger('openCloseModal', [
      transition(':enter', [
        style({ opacity: 0, transform: 'scale(0.95)' }),
        animate('200ms ease-out', style({ opacity: 1, transform: 'scale(1)' }))
      ]),
      transition(':leave', [
        style({ opacity: 1, transform: 'scale(1)' }),
        animate('150ms ease-in', style({ opacity: 0, transform: 'scale(0.95)' }))
      ])
    ])
  ]
})
export class AddCompanyAccountModalComponent implements OnInit, OnDestroy {

  @Output() onCloseModal = new EventEmitter<any>();
  @Output() onCompanyAdded = new EventEmitter<any>();

  email = '';
  password = '';
  isCompany = true; // true = "company", false = "staff"
  passwordToggleFlag = true;
  adding = false;
  submitted = false;

  constructor(
    private companiesService: CompaniesService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
  }

  ngOnDestroy(): void {
  }

  togglePasswordType() {
    this.passwordToggleFlag = !this.passwordToggleFlag;
  }

  submit() {
    this.submitted = true;
    if (!this.email || !this.password || this.adding) return;

    this.adding = true;
    const payload = {
      email: this.email.trim(),
      password: this.password,
      type: this.isCompany ? 'company' : 'staff'
    };

    this.companiesService
      .createAccountLink(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        res => {
          this.adding = false;
          this.toastr.success(res && res.message ? res.message : 'Account linked successfully', 'Success');
          this.onCompanyAdded.emit(res);
          this.close();
        },
        error => {
          this.adding = false;
          this.toastr.error(error && error.message ? error.message : 'Failed to link account', 'Error');
        }
      );
  }

  onOutsideClick(event: MouseEvent) {
    this.close();
  }

  close() {
    this.onCloseModal.emit();
  }

}

